module.exports = __webpack_public_path__ + "fonts/KaTeX_Size2-Regular.57f5c18.ttf";